import React from 'react';
import { Search } from 'lucide-react';
import { cn } from '../../utils/cn';
import { ListSortSelect } from './ListSortSelect.jsx';

/**
 * Responsive row: full-width search + sort dropdown (used on list screens).
 */
export function ListSearchSortBar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  sortValue,
  onSortChange,
  sortOptions,
  sortLabel,
  showSearch = true,
  showSort = true,
  className,
  sortId,
}) {
  if (!showSearch && !showSort) return null;

  return (
    <div className={cn('flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3', className)}>
      {showSearch && (
        <div className="relative min-w-0 flex-1">
          <Search
            className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400"
            aria-hidden
          />
          <input
            type="search"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            className="w-full rounded-xl border border-slate-300 bg-white py-3 pl-10 pr-4 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>
      )}
      {showSort && (
        <ListSortSelect
          id={sortId}
          value={sortValue}
          onChange={onSortChange}
          options={sortOptions}
          label={sortLabel}
        />
      )}
    </div>
  );
}
